import cookies from '../../src/externals/axios/helpers/cookies';
import buildFullPath from '../../src/externals/axios/core/buildFullPath';
import isURLSameOrigin from '../../src/externals/axios/helpers/isURLSameOrigin';
import { assign } from './utils';
var getXsrfHeaderGenerator = function (xsrfHeaderName, xsrfCookieName) { return function (config) {
    var _a;
    var cookieName = xsrfCookieName || xsrfHeaderName;
    var fullPath = buildFullPath(config.baseURL || '', config.url || '');
    var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && cookies.read(cookieName);
    if (!xsrfValue) {
        return {};
    }
    return _a = {},
        _a[xsrfHeaderName] = xsrfValue,
        _a;
}; };
var oldXsrfHeaderGenerator = getXsrfHeaderGenerator('ks-s-ctn');
var oldXsrfConfig = {
    xsrfHeaderGenerator: oldXsrfHeaderGenerator,
    xsrfErrorCodes: [3313, 3314, 3315],
};
export var oldAppXsrfConfig = assign({}, oldXsrfConfig, {
    refreshCsrfTokenUrl: '/rest/app/grocery/cs/ref',
});
export var oldPcXsrfConfig = assign({}, oldXsrfConfig, {
    refreshCsrfTokenUrl: '/rest/app/tts/cs/ref',
});
export var newXsrfConfig = {
    xsrfHeaderGenerator: getXsrfHeaderGenerator('KS-CSRF-Token'),
    refreshCsrfTokenUrl: '/zt/gateway/csrf/token/refresh',
    xsrfErrorCodes: [7210],
};
//# sourceMappingURL=xsrf-config.js.map